module.exports = __webpack_public_path__ + "media/voice.7364e6e1.mp3";